






































import { Vue, Component } from 'vue-property-decorator';
import ScheduleMeetingDialog from '@/components/brand/ScheduleMeetingDialog.vue';
import MenuCard from '@/components/brand/MenuCard.vue';
import PageHeaderOverlay from '@/components/brand/PageHeaderOverlay.vue';
import Confetti from 'vue-confetti';
import { LEARN_ABOUT_DESC } from '../../common/brand.config';
import brandModule from '../../store/modules/brand.module';

@Component({
  components: {
    ScheduleMeetingDialog,
    MenuCard,
    PageHeaderOverlay,
  },
})
export default class LearningCenterPage extends Vue {
  learnItems = [];

  learnAboutBody = '';

  mounted(): void {
    this.learnItems = this.$store.getters.learnItems;
    this.learnAboutBody = this.$store.getters.learnAboutBody;
  }

  get brandDescription() {
    if (!brandModule.brand) {
      return;
    }
    return brandModule.brand.description;
  }

  get brandName() {
    if (!brandModule.brand) {
      return;
    }
    return brandModule.brand.name;
  }

  get brandSecondaryColor() {
    if (!brandModule.brand) {
      return '#293645';
    }
    return brandModule.brand.secondary_color;
  }

  cueConfetti() {
    Confetti.start();
    setTimeout(() => {
      Confetti.stop();
    }, 2000);
  }
}
